/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Auth_Desc4Inputs */

const en_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, session-based, and role-scoped access, plus refresh flows that don't get hacked on the frontend.`)
};

const ar_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT وOAuth ووصول قائم على الجلسات وحسب الدور, مع تدفقات تحديث لا تُخترق في الواجهة الأمامية.`)
};

const bn_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, সেশন-ভিত্তিক ও রোল-স্কোপড অ্যাক্সেস, সাথে এমন রিফ্রেশ ফ্লো যা ফ্রন্টএন্ডে হ্যাক হয় না।`)
};

const de_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, sitzungsbasierter und rollenbezogener Zugriff sowie Refresh-Flows, die im Frontend nicht gehackt werden.`)
};

const es_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso JWT, OAuth, basado en sesión y por roles, además de flujos de refresco que no son hackeados en el frontend.`)
};

const fr_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès JWT, OAuth, basé sur la session et limité aux rôles, ainsi que des flux de refresh qui ne sont pas hackés sur le frontend.`)
};

const pt_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, acesso baseado em sessão e com escopo de função, além de fluxos de atualização que não são hackeados no front-end.`)
};

const zh_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT、OAuth、会话加角色权限，还有在前端不会被黑的刷新流程。`)
};

const tr_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, oturum ve rol bazlı erişim ile ön uçta hack'lenmeyen yenileme akışları.`)
};

const ru_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JWT, OAuth, доступ по сессиям и ролям плюс рефреш-флоу, которые не хакнут на фронтенде.`)
};

const pl_svc_backend_development_auth_desc4 = /** @type {(inputs: Svc_Backend_Development_Auth_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostęp JWT, OAuth, sesyjny i rolowy plus refresh flow, których nie zhakują na frontendzie.`)
};

/**
* | output |
* | --- |
* | "JWT, OAuth, session-based, and role-scoped access, plus refresh flows that don't get hacked on the frontend." |
*
* @param {Svc_Backend_Development_Auth_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_auth_desc4 = /** @type {((inputs?: Svc_Backend_Development_Auth_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Auth_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_auth_desc4(inputs)
	if (locale === "bn") return bn_svc_backend_development_auth_desc4(inputs)
	if (locale === "de") return de_svc_backend_development_auth_desc4(inputs)
	if (locale === "es") return es_svc_backend_development_auth_desc4(inputs)
	if (locale === "fr") return fr_svc_backend_development_auth_desc4(inputs)
	if (locale === "pt") return pt_svc_backend_development_auth_desc4(inputs)
	if (locale === "zh") return zh_svc_backend_development_auth_desc4(inputs)
	if (locale === "tr") return tr_svc_backend_development_auth_desc4(inputs)
	if (locale === "ru") return ru_svc_backend_development_auth_desc4(inputs)
	if (locale === "pl") return pl_svc_backend_development_auth_desc4(inputs)
	return en_svc_backend_development_auth_desc4(inputs)
});
export { svc_backend_development_auth_desc4 as "svc_backend-development_AUTH_desc" }